import React from 'react'
import PropTypes from 'prop-types'
import TableHeader from './TableHeader'

const FilteringHeaderRow = ({filterOptionsDictionary, filterRules, isVersetzungsplan}) =>
  filterOptionsDictionary.map(entry => {
    const showAscAndDescSortingOption = entry.type !== 'modules' && !isVersetzungsplan
    return (
      <TableHeader
        key={entry.type}
        type={entry.type}
        displayName={entry.displayName}
        options={entry.options}
        filterRules={filterRules.filter(rule => rule.type === entry.type)}
        isVersetzungsplan={isVersetzungsplan}
        showAscAndDescSortingOption={showAscAndDescSortingOption}
      />
    )
  })

FilteringHeaderRow.propTypes = {
  filterOptionsDictionary: PropTypes.array,
  filterRules: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      rule: PropTypes.string,
    }),
  ),
  isVersetzungsplan: PropTypes.bool,
}

export default FilteringHeaderRow
